import React, {Component} from 'react'
import { Table } from 'components/UI'
import {browserHistory} from 'react-router'
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import LessonStatusTd from './LessonStatusTd'
import SelectStudentModal from 'template/Modals/SelectStudent'
import Student from 'mediators/Student';
import addMultiStudentToClass from 'controllers/class/addStudentToMultiClass'
import {fetchClassStudent} from './ducks'
import './StudentTable.scss'
import StudentName from 'components/StudentName';
import __R, { userCan } from 'containers/__R';
import locale from '../locale'
import CreateClassModal from 'template/Modals/CreateClass'
import CreateClassOneModal from 'template/Modals/CreateClassOne'
import Tooltip from 'react-tooltip';

const CONTROLLER_WIDTH = '150px';

class StudentTable extends Component {
  constructor(props){
    super(props)
    this.fields = [{
      name: 'schoolStudentName',
      title: __('Class Student', 'classdetail'),
      getTdProps: ({trData}) => {
        const {classStudentState} = trData
        return {
          style: {width: "16%", opacity: classStudentState === 0 ? 0.35 : 1}
        }
      },
      getTdContent: ({ trData: studentInfo })=>{
        return (
          <__R can="read_class_student" by="disable">
            <StudentName id={studentInfo.schoolStudentID} name={studentInfo.schoolStudentName} checkStudentUpdate={(isUpdated)=>{
              this.checkStudentUpdate(isUpdated)
            }} />
          </__R>
        )
      }
    },
    {
      name: 'arrangeLessonCount',
      title: __('Lesson Count', 'classdetail'),
      getTdProps: ({trData}) => {
        const {classStudentState} = trData
        return {
          style: {width: "16%", opacity: classStudentState === 0 ? 0.35 : 1}
        }
      }
    },
    {
      name: 'class_status',
      title: __('Class Status', 'student'),
      getTdProps: ({trData}) => {
        const {classStudentState} = trData
        return {
          style: {width: "16%", opacity: classStudentState === 0 ? 0.35 : 1}
        }
      },
      getTdContent: ({ trData: studentInfo })=>{
        return <LessonStatusTd studentInfo={studentInfo} />
      }
    },
    {
      name: 'tuition_consumption',
      title: __('Used/Paid', locale),
      getTdProps: ({trData}) => {
        const {classStudentState} = trData
        return {
          style: {width: "16%", opacity: classStudentState === 0 ? 0.35 : 1}
        }
      },
      getTdContent: ({ trData: studentInfo })=>{
        const currency = this.props.schoolDetail.detail.currency
        const tuition_consumption = studentInfo.tuition_consumption
        const paidInFee = studentInfo.paidInFee
        const id = 'student-id-' + studentInfo.schoolStudentID;

        if(tuition_consumption === null){
          return (<div style={{cursor: 'pointer'}} onClick={() => {
            if(this.props.classDetail.detail.cType == 0){
              CreateClassModal({mode: 'update', id: this.props.classDetail.detail.classID})
            } else if (this.props.classDetail.detail.cType == 1){
              CreateClassOneModal({mode: 'update', id: this.props.classDetail.detail.classID})
            }
          }}>{__('Setup', locale)}</div>)
        } else {
          if(studentInfo.total_discount_amount > 0){
            return (
              <div>
                {tuition_consumption + '/' + paidInFee + currency}
                <i className='fa icon-tag' data-tip data-for={id}></i>
                <Tooltip
                  id={id}
                  effect='solid'
                  place='bottom'
                  type='info'
                  getContent={()=> { return __('Discounted', locale) + ' ' + studentInfo.total_discount_amount + ' ' + currency; }}
                />
              </div>
            )
          } else {
            return (<div>{tuition_consumption + '/' + paidInFee + currency}</div>)
          }
        }
      }
    },
    {
      name: 'usedLessonCount',
      title: __('Checked In', 'classdetail'),
      getTdProps: ({trData}) => {
        const {classStudentState} = trData
        return {
          style: {width: "16%", opacity: classStudentState === 0 ? 0.35 : 1}
        }
      }
    }]
  }
  checkStudentUpdate(isUpdated) {
    const {tableData, dispatch} = this.props
    const {classID} = tableData
    if(isUpdated) {
      dispatch(fetchClassStudent(classID));
    }
  }
  render(){
    const {tableData, dispatch, settings, classDetail, title} = this.props
    const {classStudentList, classID} = tableData
    const {cType, cState} = classDetail.detail

    if(!classStudentList){
      return ( <div /> )
    }

    let schoolId = localStorage.getItem('schoolId')

    return(
      <Table
        data={classStudentList}
        fields={this.fields}
        className='classdetail-student-table'
        settingThTitle={__('Settings', 'class')}
        settingWidth={CONTROLLER_WIDTH}
        settings={settings}
        useMultiSelection={false}
        oneSettingPerRow={false}
        dropdownGuideWidth={160}
        dropdownGuideHeight={228}
        usePagination={false}
        hasTopUtilSection={true}
        topUtilSection={
          <div>
            <div className='lesson-student-table'>
              <span className='title'>{__('Students: ', 'studentTable')}</span>
              <span  className='student-count'>{classStudentList.length}</span>
              <button className='btn btn-primary' style={{visibility: 'hidden'}}>TEST</button>
              {title == 'student' && <__R can='assign_student_to_class' by='disable'>
                <button className='pull-right btn btn-primary' disabled={cState == 0 ? true : false} onClick={() => {
                  SelectStudentModal({
                    schoolId,
                    selectMultiple: true,
                    selected: classStudentList.map((s) => {
                      return new Student(s)
                    })
                  })
                  .then((res) => {
                    let arr = [];
                    res.map((student) => {
                      arr.push(student.id)
                    })
                    addMultiStudentToClass(classID, arr)
                    .then((res) => {
                      dispatch(fetchClassStudent(classID))
                    })
                  })
                }}>{__('New Student', 'student')}</button>
              </__R>}
            </div>
          </div>
        }
      />
    )
  }
}


export default (StudentTable)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/StudentTable/index.js